import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { enviroment } from "../enviroment";
import { isNoAnalyticsRoute } from "../utils/analytics/analyticsRoutes";
import {
  applyStoredConsent,
  resendIdentity,
  stopAnalytics,
} from "../utils/analytics/clarity";

// RootLayout hook (flag REACT_APP_CLARITY_CONSENT_ENABLED): runs at mount
// and on every pathname change - the SPA meaning of "on every page load".
// /public* and /approval* never get analytics (stop, also when reached by
// SPA navigation); everywhere else a stored "granted" loads the tags
// (idempotent) and re-sends the consent signals, and with the facade flag
// the page-bound tags + identify are sent again for THIS page (design
// B13). Search changes alone do nothing. Flag off = the effect returns at
// once; no call, no read.
export function useClarityConsentPageView(): void {
  const { pathname } = useLocation();
  useEffect(() => {
    if (!enviroment.clarityConsentEnabled) return;
    if (isNoAnalyticsRoute(pathname)) {
      stopAnalytics();
      return;
    }
    applyStoredConsent();
    if (enviroment.clarityEnabled) resendIdentity();
  }, [pathname]);
}
